import { motion } from "framer-motion";
import { Check, GraduationCap, Video, Users, Infinity as InfinityIcon } from "lucide-react";
import { Cta, Reveal } from "@/components/landing/Shared";

const LEARN = [
  "Get paid to review products (Amazon, TikTok Shop)",
  "Monetize your scroll time with UGC",
  "Make money with Print-on-Demand, Letter Writing, and Etsy",
  "Create faceless content using AI",
  "Launch digital products without being a guru",
  "Grow passive income streams (KDP, Pinterest, Affiliate)",
];

const FEATURES = [
  { icon: GraduationCap, title: "30+ Income Stream Trainings", text: "Step-by-step lessons for Amazon reviews, UGC, Etsy, AI tools, TikTok shop, and more." },
  { icon: Video, title: "Zoom Calls (Weekly)", text: "Beginner Zooms, Tech Zooms, Mindset Mondays. We walk with you." },
  { icon: Users, title: "Private Community Access", text: "Ask questions, cry if you need to, get love and answers fast." },
  { icon: InfinityIcon, title: "Lifetime Access to Everything", text: "Including updates, new trainings, and community perks." },
];

export const BossSuite = () => (
  <section className="bg-white px-5 py-24 sm:px-8 lg:px-14 lg:py-32" data-testid="section-boss-suite">
    <div className="mx-auto max-w-6xl">
      <Reveal className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[var(--mauve)]">Introducing</p>
        <h2 className="font-display mt-4 text-5xl font-light tracking-tight sm:text-6xl lg:text-7xl" data-testid="boss-suite-heading">The Boss Suite</h2>
        <p className="mx-auto mt-5 max-w-xl text-lg text-[var(--muted)] sm:text-xl">30+ Ways to Start Making Money Online. On Your Terms.</p>
      </Reveal>

      <div className="mt-16 grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <h3 className="font-display text-2xl sm:text-3xl">You'll learn how to:</h3>
          <ul className="mt-6 space-y-4" data-testid="learn-list">
            {LEARN.map((l) => (
              <li key={l} className="flex gap-4 text-base leading-relaxed text-[var(--ink)] sm:text-lg">
                <span className="mt-1 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[var(--blush)] text-[var(--mauve-dark)]"><Check className="h-3.5 w-3.5" aria-hidden="true" /></span>
                {l}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.1}>
          <img
            src="/photos/community.jpg"
            alt="A large group of smiling women from The Boss Suite community posing together on the porch of a dark wooden house"
            loading="lazy"
            className="aspect-[4/5] w-full rounded-3xl border-[6px] border-white object-cover object-[50%_58%] shadow-[0_30px_60px_-30px_rgba(38,65,67,0.5)]"
            data-testid="boss-suite-photo"
          />
        </Reveal>
      </div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="feature-cards">
        {FEATURES.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ y: -6 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-3xl border border-[var(--blush-deep)] bg-[var(--cream)] p-7"
          >
            <f.icon className="h-7 w-7 text-[var(--mauve)]" aria-hidden="true" />
            <h3 className="font-display mt-5 text-xl">{f.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{f.text}</p>
          </motion.div>
        ))}
      </div>

      <Reveal className="mx-auto mt-16 max-w-3xl text-center">
        <p className="font-display text-2xl italic leading-snug sm:text-3xl">Starting from scratch? Nervous to show your face? Not sure where to begin? You won’t be left figuring it out alone. I’m here to support you personally, every step of the way.</p>
        <div className="mt-10"><Cta testId="boss-suite-cta-button" label="I need this - join now" href="#get-access" /></div>
      </Reveal>
    </div>
  </section>
);
